import * as React from 'react'
import {
  EnrichedSettingsCategory,
  getSettingsCategory, isCloudHub2Category, isCloudHubCategory,
  isRTFCategory,
  SettingsCategory
} from './util/SettingsConfigurations'
import { RuntimeFabricSettingsPage } from './Body/RuntimeFabric/RuntimeFabricSettingsPage'
import { Props as SidebarProps, SettingsSidebar } from './Sidebar/SettingsSidebar'
import { Props as ContentProps, SettingsBody } from './Body/common/SettingsBody'
import { hideIfPCEOrGovCloud, isGovCloud, isPCE, isPCEOrGov } from '../../util/environments'
import CloudHubSettingsPageContainer from './Body/CloudHub/CloudHubSettingsPageContainer'
import HybridSettingsPageContainer from './Body/Hybrid/HybridSettingsPageContainer'
import './SettingsPage.css'
import { CloudHub2SettingsPage } from './Body/CloudHub2/CloudHub2SettingsPage';

export type ExternalProps = {
  selectedCategory?: string
  selectedEnvironment?: string
}

export type ValueProps = ExternalProps & {
  selectedEnrichedCategory?: EnrichedSettingsCategory
}

export type EventProps = {
  changeCategory: (category: EnrichedSettingsCategory) => void
  changeEnvironment: (category: EnrichedSettingsCategory, envId: string) => void
  initSettings: (selectedCategory?: string, selectedEnvironment?: string) => void
}

export type Props = ValueProps & EventProps

export const enrichedSettingsCategories: EnrichedSettingsCategory[] = [
  {
    url: 'cloudhub',
    category: SettingsCategory.CloudHub,
    content: <CloudHubSettingsPageContainer/>,
    hideForPCE: true
  },
  {
    url: 'cloudhub2',
    category: SettingsCategory.CloudHub2,
    content: <CloudHub2SettingsPage/>,
    hideForPCE: true,
    hideForGovCloud: true
  },
  {
    url: 'hybrid',
    category: SettingsCategory.Hybrid,
    content: <HybridSettingsPageContainer/>
  },
  {
    url: 'runtime-fabric',
    category: SettingsCategory.RTF,
    content: <RuntimeFabricSettingsPage/>,
    hideForPCE: true,
    hideForGovCloud: true
  }
]

export const getEnrichedCategory = (url?: string): EnrichedSettingsCategory | undefined => {
  return enrichedSettingsCategories.find(esc => esc.url === url)
}

export const getEnrichedCategoryByCategory = (category?: string): EnrichedSettingsCategory => {
  return enrichedSettingsCategories.find(esc => esc.category === category) || enrichedSettingsCategories[1]
}

export class SettingsPage extends React.Component<Props, {}> {

  private static getCategoryForPCE(selectedCategory: string | undefined): SettingsCategory {
    return selectedCategory && !isCloudHubCategory(selectedCategory) && !isCloudHub2Category(selectedCategory) &&
      !isRTFCategory(selectedCategory) ? getSettingsCategory(selectedCategory) : SettingsCategory.Hybrid
  }

  private static getCategoryForGovCloud(selectedCategory: string | undefined): SettingsCategory {
    return selectedCategory && !isCloudHub2Category(selectedCategory) &&
      !isRTFCategory(selectedCategory) ? getSettingsCategory(selectedCategory) : SettingsCategory.CloudHub
  }

  constructor(props: Props) {
    super(props)

    this.onSidebarView = this.onSidebarView.bind(this)

    if (!isPCEOrGov()) {
      this.props.initSettings(props.selectedCategory, props.selectedEnvironment)
    } else {
      const category = isPCE() ?
          SettingsPage.getCategoryForPCE(props.selectedCategory) : SettingsPage.getCategoryForGovCloud(props.selectedCategory)

      if (props.selectedCategory && getSettingsCategory(props.selectedCategory) === category) {
        this.props.initSettings(props.selectedCategory, props.selectedEnvironment)
      } else {
        this.props.changeCategory(getEnrichedCategoryByCategory(category))
      }
    }
  }

  getSidebarProps(): SidebarProps {
    let selectedCategory = this.props.selectedEnrichedCategory ? this.props.selectedEnrichedCategory.category : enrichedSettingsCategories[0].category

    if (isPCE()) {
      selectedCategory = SettingsPage.getCategoryForPCE(selectedCategory)
    } else if (isGovCloud()) {
      selectedCategory = SettingsPage.getCategoryForGovCloud(selectedCategory)
    }

    return {
      onClick: this.onSidebarView,
      selectedCategory: selectedCategory,
      categories: enrichedSettingsCategories
          .filter(cat => !hideIfPCEOrGovCloud(cat.hideForPCE, cat.hideForGovCloud))
          .map(category => category.category)
    }
  }

  getContentProps(): ContentProps {
    let selectedCategory = this.props.selectedEnrichedCategory ? this.props.selectedEnrichedCategory : enrichedSettingsCategories[0]

    if (isPCE()) {
      selectedCategory = selectedCategory.category !== SettingsCategory.CloudHub && selectedCategory.category !== SettingsCategory.RTF ?
        selectedCategory : enrichedSettingsCategories[1]
    } else if (isGovCloud()) {
      selectedCategory = selectedCategory.category !== SettingsCategory.RTF ? selectedCategory : enrichedSettingsCategories[0]
    }

    return {
      selectedCategory: selectedCategory
    }
  }

  onSidebarView(category: SettingsCategory) {
    const selectedCategory = enrichedSettingsCategories.find(enrichedSettingsCategory => enrichedSettingsCategory.category === category)

    if (selectedCategory) {
      this.props.changeCategory(selectedCategory)
    }
  }

  render() {
    const sidebarProps = this.getSidebarProps()
    const contentProps = this.getContentProps()

    return (
      <div className="settings-page">
        <div className="settings-page-container">
          <SettingsSidebar {...sidebarProps}/>
          <SettingsBody {...contentProps}/>
        </div>
      </div>
    )
  }
}
